import script from "./rec-check-box.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-check-box.vue?vue&type=script&lang=ts&setup=true"

import "./rec-check-box.vue?vue&type=style&index=0&id=7730957e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7730957e"]])

export default __exports__